import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { BUSNQuoteScheduleService } from '@takectrl-multiapp/svcs-core-business';
import { IPriorityRating, SharedConfig, SharedDialogService } from '@takectrl-multiapp/svcs-share-config';
import { BUSNThirdPartyService } from '@takectrl-multiapp/svcs-core-business';
declare const dataLayer: any[];

@Component({
  selector: 'needs-results',
  standalone: false,
  templateUrl: './needs-results.component.html',
  styleUrls: ['./needs-results.component.scss'],
})
export class NeedsResultsComponent implements OnInit {
  @Output() navigateToQuoteScreenAfterQuoteRequest: EventEmitter<void> = new EventEmitter<void>();
  @Output() navigateToNeedsSliders: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Output() navigateToQuoteNew: EventEmitter<unknown> = new EventEmitter<unknown>();
  @Input() priorityRatings: Array<IPriorityRating>;
  showSuccess = false;
  showFetchingQuotesAnimation = false;
  constructor(
    public busnQuoteScheduleService: BUSNQuoteScheduleService,
    public sharedConfig: SharedConfig,
    public loadingCtrl: LoadingController,
    private readonly busnThirdPartyService: BUSNThirdPartyService,
    private readonly sharedDialogService: SharedDialogService
  ) {}

  ngOnInit(): void {
    
      dataLayer.push({
        event: 'page_show',
        screenPath: 'needs-results',
        screenName: 'needs-results',
        userUid: SharedConfig.firebaseUserKey ? SharedConfig.firebaseUserKey : 'NaN',
      });
      this.cantQuote = this.cantQuote.bind(this);
  }

  navNeedsSliders(pageName: string) {
    this.navigateToNeedsSliders.emit({ pageName: pageName, rankings: [] });
  }

  cantQuote() {
    this.navigateToQuoteNew.emit();
    this.sharedDialogService.hidePopupDialog();
  }

  async submitQuoteRequest() {
    if (this.sharedConfig.userPermissions?.can_quote) {
      this.showFetchingQuotesAnimation = true;
      SharedConfig.showFullScreen = true;
      SharedConfig.quoteRequest.fna = this.priorityRatings;
    this.busnQuoteScheduleService.submitQuoteRequest().then( (response) => {
        this.showFetchingQuotesAnimation = false;
        if (response.success) {
          this.showSuccess = true;
        } else {
          this.sharedDialogService.showPopupDialog({
            header: 'Something went wrong',
            subHeader: response.message,
            buttonOneText: 'OK',
            buttonOneCallback: this.sharedDialogService.hidePopupDialog,
          });
        }
      });
    } else {
      this.sharedDialogService.showPopupDialog({
          header: 'Please note!',
          subHeader: 'Quoting has been disbled.',
          buttonOneText: 'OK',
          buttonOneCallback: this.cantQuote,
        });
    }
  }
}
